"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchLoginAndRegister = void 0;
const store_1 = require("@/state/store");
const dataLayerLogin_1 = require("@/services/dataLayerLogin");
const switchLoginAndRegister = (buttonPosition) => {
    var _a;
    // Tracking (muss vor dem switch passieren, damit der Klick auf der aktuellen Form getrackt wird
    const trackingAction = buttonPosition === "Bottom" ? "SwitchForm_2" : "SwitchForm";
    (0, dataLayerLogin_1.pushEvent)(trackingAction);
    // switch form
    store_1.store.isLogin = !store_1.store.isLogin;
    // focus for accessiblity
    (_a = document.getElementById("loginRegisterModalHeadlineId")) === null || _a === void 0 ? void 0 : _a.focus();
};
exports.switchLoginAndRegister = switchLoginAndRegister;
